import React from 'react';
import TooltipTrigger from 'react-popper-tooltip';

import {
    StyledTooltipSpan,
    TooltipContainer,
    TooltipArrow,
} from './StyledTooltip';
const   TooltipReorder = ({ children, tooltip, hideArrow, isButton = false, ...props }) => (
    <TooltipTrigger
        {...props}
        trigger={window.innerWidth <= 992 && !isButton ? 'click' : props.trigger}
        tooltip={({
            arrowRef,
            tooltipRef,
            getArrowProps,
            getTooltipProps,
            placement,
        }) => (
            <TooltipContainer
                {...getTooltipProps({
                    ref: tooltipRef,
                    className: 'tooltip-container tooltip--reorder',
                })}
            >
                {!hideArrow && (
                    <TooltipArrow
                        {...getArrowProps({
                            ref: arrowRef,
                            className: 'tooltip-arrow',
                            'data-placement': placement,
                        })}
                    />
                )}
                {tooltip}
            </TooltipContainer>
        )}
    >
        {({ getTriggerProps, triggerRef }) => (
            <StyledTooltipSpan
                {...getTriggerProps({
                    ref: triggerRef,
                    className: 'trigger',
                })}
            >
                {children}
            </StyledTooltipSpan>
        )}
    </TooltipTrigger>
);

export default TooltipReorder;
